import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { NavigationTreeNodeLoading } from '../NavigationTreeNode';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: undefined,
};

const NavigationTreeLoading = ({
  className,
}) => {
  const classes = cx(
    styles.loadingIndicator,
    className,
  );

  return (
    <ul className={classes}>
      <NavigationTreeNodeLoading>
        <NavigationTreeNodeLoading />
        <NavigationTreeNodeLoading />
        <NavigationTreeNodeLoading />
      </NavigationTreeNodeLoading>
      <NavigationTreeNodeLoading />
      <NavigationTreeNodeLoading>
        <NavigationTreeNodeLoading />
        <NavigationTreeNodeLoading />
        <NavigationTreeNodeLoading />
        <NavigationTreeNodeLoading />
      </NavigationTreeNodeLoading>
    </ul>
  );
};

NavigationTreeLoading.propTypes = propTypes;
NavigationTreeLoading.defaultProps = defaultProps;

export default NavigationTreeLoading;
